import { createStore, combineReducers, compose } from 'redux';
import { loadState, saveState } from './sessionStorage';
import { appReducer } from 'App';


/*
 * Get Redux store from sessionStorage
 *
 * @since 1.0.0
 */

const persistedState = loadState();




/*
 * Combine Redux reducers
 *
 * @since 1.0.0
 */

const reducers = combineReducers({
  app: appReducer
});




/*
 * Create the Redux store
 *
 * @since 1.0.0
 */

const store = createStore(
  reducers,
  persistedState,
  compose
);


// Listen for state changes and update state in sessionStorage
store.subscribe(() => {
	saveState(store.getState());
});


export default store;



// WEBPACK FOOTER //
// ./app/src/store.js